import { render, staticRenderFns } from "./PropertyStatusMessage.vue?vue&type=template&id=878c269c&scoped=true&"
import script from "./PropertyStatusMessage.vue?vue&type=script&lang=js&"
export * from "./PropertyStatusMessage.vue?vue&type=script&lang=js&"
import style0 from "./PropertyStatusMessage.vue?vue&type=style&index=0&id=878c269c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c269c",
  null
  
)

export default component.exports